export default function isOnline() {
    return navigator.onLine;
}
